/* global VXConfig */

'use strict';

import Constants from '../Constants';
import NotificationStore from './NotificationStore';
import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';

const IncomingCommandTypes = Constants.ApiTypes.Notification.Incoming;

const ChangeEvents = {
	favoriteActors: 'favoriteActors',
	actorPinned: 'actorPinned',
	actorUnpinned: 'actorUnpinned',
	albumPinned: 'albumPinned',
	sedcardsAlbumPinned: 'sedcardsAlbumPinned',
	picturePinned: 'picturePinned',
};

/*
 * data
 */

const favoriteActorsData = {
	items: [],
	onlineCount: 0,
	pinnedIds: false,
};

/**
 * @param command
 */
function handleIncomingCommand(command) {
	if (typeof command.type === 'string') {
		switch (command.type) {
			case IncomingCommandTypes.FAVORITE_ACTOR_PINNED:
				FavoriteStore.emit(ChangeEvents.actorPinned, command.actorId, true);
				break;
			case IncomingCommandTypes.FAVORITE_ACTOR_UNPINNED:
				FavoriteStore.emit(ChangeEvents.actorUnpinned, command.actorId, false);
				break;
			case IncomingCommandTypes.FAVORITE_ALBUM_PINNED:
				FavoriteStore.emit(ChangeEvents.albumPinned, command.albumId, true);
				break;
			case IncomingCommandTypes.FAVORITE_ALBUM_UNPINNED:
				FavoriteStore.emit(ChangeEvents.albumPinned, command.albumId, false);
				break;
			case IncomingCommandTypes.FAVORITE_SEDCARDS_ALBUM_PINNED:
				FavoriteStore.emit(ChangeEvents.sedcardsAlbumPinned, command.actorId, true);
				break;
			case IncomingCommandTypes.FAVORITE_SEDCARDS_ALBUM_UNPINNED:
				FavoriteStore.emit(ChangeEvents.sedcardsAlbumPinned, command.actorId, false);
				break;
			case IncomingCommandTypes.FAVORITE_PICTURE_PINNED:
				FavoriteStore.emit(ChangeEvents.picturePinned, command.pictureId, true);
				break;
			case IncomingCommandTypes.FAVORITE_PICTURE_UNPINNED:
				FavoriteStore.emit(ChangeEvents.picturePinned, command.pictureId, false);
				break;
			case IncomingCommandTypes.FAVORITE_ACTORS:
				favoriteActorsData.items = command.items;
				favoriteActorsData.onlineCount = command.onlineCount;
				FavoriteStore.emit(ChangeEvents.favoriteActors);
				break;
			case IncomingCommandTypes.ACTOR_ONLINE:
			case IncomingCommandTypes.ACTOR_OFFLINE:
				handleActorOnlineOffline(command);
				break;
			default:
				break;
		}
	}
}

function handleActorOnlineOffline(command) {
	for (let i = 0; i < favoriteActorsData.items.length; i++) {
		if (command.actorId === favoriteActorsData.items[i].id) {
			const oldState = favoriteActorsData.items[i].isOnline;
			const newState = command.type === IncomingCommandTypes.ACTOR_ONLINE;

			if (oldState !== newState) {
				favoriteActorsData.items[i].isOnline = newState;

				if (newState) {
					favoriteActorsData.onlineCount++;
				} else {
					favoriteActorsData.onlineCount--;
				}

				FavoriteStore.emit(ChangeEvents.favoriteActors);
			}

			break;
		}
	}
}

const FavoriteStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: ChangeEvents,

	getActors: function () {
		return favoriteActorsData.items;
	},

	getOnlineCount: function () {
		return favoriteActorsData.onlineCount;
	},

});

// init
FavoriteStore.setMaxListeners(0);
NotificationStore.addEventListener(NotificationStore.EVENTS.favorite, handleIncomingCommand);
if (VXConfig.guestIsLoggedIn) {
	NotificationStore.Favorite.requestActors();
}

export default FavoriteStore;
